export const SOCIAL_IMAGE_PROBABILITY = 0.25;

// Decide once per feed, not during rendering or when more cards are revealed.
export function attachSocialImages(cards, images, random = Math.random) {
  const available = [...images];
  return cards.map(card => {
    if (!available.length || random() >= SOCIAL_IMAGE_PROBABILITY) return card;
    const index = Math.floor(random() * available.length);
    const image = available[index];
    available[index] = available[available.length - 1];
    available.pop();
    return { ...card, image };
  });
}
